import produce from 'immer';
import { GET_BRAND_VOICE_SETTINGS, GET_BRAND_VOICE_SETTINGS_NOT_FOUND, GET_CONTENT_ASSISTANT_SETTINGS } from 'ContentEditorUI/redux/actions/actionTypes';
import { BrandVoiceChannels } from 'ui-brand-identity-lib/constants/BrandVoice';
// If you are adding Brand Voice / Brand Identity to a new editor, consider useBrandVoiceOptions hook instead!
const INITIAL_BRAND_VOICE_OPTIONS = {
  isSetUp: false,
  isEnabledForApp: false,
  businessUnitId: 0
};
const initialState = {
  contentAssistanceEnabled: false,
  blogBrandVoice: INITIAL_BRAND_VOICE_OPTIONS,
  emailBrandVoice: INITIAL_BRAND_VOICE_OPTIONS,
  smsBrandVoice: INITIAL_BRAND_VOICE_OPTIONS,
  pageBrandVoice: INITIAL_BRAND_VOICE_OPTIONS,
  caseStudyBrandVoice: INITIAL_BRAND_VOICE_OPTIONS,
  blogBrandVoiceEnabled: false,
  generativeAiEnabled: false,
  crmPropertiesEnabled: false,
  isLoading: true
};
const getVoiceDataForChannel = (brandVoiceSettings, channelType) => {
  const {
    channelOverrides,
    voiceData
  } = brandVoiceSettings || {};
  const {
    personality
  } = voiceData || {};
  let {
    tone
  } = voiceData || {};
  const overridesForChannel = channelOverrides && channelOverrides[channelType];
  if (overridesForChannel) {
    const toneOverrides = overridesForChannel[0] && overridesForChannel[0].tone;
    tone = toneOverrides && toneOverrides.length ? toneOverrides : tone;
  }
  return {
    personality,
    tone
  };
};
const updateBrandVoiceBusinessUnitId = (draft, businessUnitId) => {
  draft.blogBrandVoice = Object.assign({}, draft.blogBrandVoice, {
    businessUnitId
  });
  draft.emailBrandVoice = Object.assign({}, draft.emailBrandVoice, {
    businessUnitId
  });
  draft.smsBrandVoice = Object.assign({}, draft.smsBrandVoice, {
    businessUnitId
  });
  draft.pageBrandVoice = Object.assign({}, draft.pageBrandVoice, {
    businessUnitId
  });
  draft.caseStudyBrandVoice = Object.assign({}, draft.caseStudyBrandVoice, {
    businessUnitId
  });
};
const updateBrandVoiceData = ({
  draft,
  brandVoiceSettings
}) => {
  if (brandVoiceSettings) {
    const {
      channelSettings
    } = brandVoiceSettings || {};
    draft.blogBrandVoice = {
      isSetUp: true,
      businessUnitId: brandVoiceSettings.businessUnitId,
      isEnabledForApp: channelSettings && channelSettings.includes(BrandVoiceChannels.BLOG),
      voiceData: getVoiceDataForChannel(brandVoiceSettings, BrandVoiceChannels.BLOG),
      voiceChannel: BrandVoiceChannels.BLOG
    };
    draft.emailBrandVoice = {
      isSetUp: true,
      businessUnitId: brandVoiceSettings.businessUnitId,
      isEnabledForApp: channelSettings && channelSettings.includes(BrandVoiceChannels.EMAIL),
      voiceData: getVoiceDataForChannel(brandVoiceSettings, BrandVoiceChannels.EMAIL),
      voiceChannel: BrandVoiceChannels.EMAIL
    };
    draft.smsBrandVoice = {
      isSetUp: true,
      businessUnitId: brandVoiceSettings.businessUnitId,
      isEnabledForApp: channelSettings && channelSettings.includes(BrandVoiceChannels.SMS),
      voiceData: getVoiceDataForChannel(brandVoiceSettings, BrandVoiceChannels.SMS),
      voiceChannel: BrandVoiceChannels.SMS
    };
    draft.pageBrandVoice = {
      isSetUp: true,
      businessUnitId: brandVoiceSettings.businessUnitId,
      isEnabledForApp: channelSettings && channelSettings.includes(BrandVoiceChannels.PAGES),
      voiceData: getVoiceDataForChannel(brandVoiceSettings, BrandVoiceChannels.PAGES),
      voiceChannel: BrandVoiceChannels.PAGES
    };
    draft.caseStudyBrandVoice = {
      isSetUp: true,
      businessUnitId: brandVoiceSettings.businessUnitId,
      isEnabledForApp: channelSettings && channelSettings.includes(BrandVoiceChannels.CASE_STUDIES),
      voiceData: getVoiceDataForChannel(brandVoiceSettings, BrandVoiceChannels.CASE_STUDIES),
      voiceChannel: BrandVoiceChannels.CASE_STUDIES
    };
  }
};
export const contentAssistantReducer = (state = initialState, action) => produce(state, draft => {
  switch (action.type) {
    case GET_CONTENT_ASSISTANT_SETTINGS:
      {
        draft.isLoading = false;
        draft.contentAssistanceEnabled = action.payload.contentAssistanceEnabled;
        draft.blogBrandVoiceEnabled = action.payload.blogBrandVoiceEnabled;
        draft.generativeAiEnabled = action.payload.generativeAiEnabled;
        draft.crmPropertiesEnabled = action.payload.crmPropertiesEnabled;
        const {
          brandVoiceSettings
        } = action.payload;
        updateBrandVoiceData({
          draft,
          brandVoiceSettings
        });
        return draft;
      }
    case GET_BRAND_VOICE_SETTINGS:
      {
        const {
          brandVoiceSettings
        } = action.payload;
        updateBrandVoiceData({
          draft,
          brandVoiceSettings
        });
        return draft;
      }
    case GET_BRAND_VOICE_SETTINGS_NOT_FOUND:
      {
        const {
          businessUnitId
        } = action.payload;
        updateBrandVoiceBusinessUnitId(draft, businessUnitId);
        return draft;
      }
    default:
      return draft;
  }
});
export default contentAssistantReducer;